import React from "react"
import { Button } from "reactstrap"
import PropTypes from "prop-types"
import StatusBadge from "components/Common/StatusBadge"
import DeleteModal from "components/Common/DeleteModal"
import EditPackageModal from "./EditClientModal"
import useDisclosure from "hooks/useDisclosure"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import useParamsQuery from "hooks/useParamsQuery"
import moment from "moment"
import { toast } from "react-toastify"
import { deletePackage } from "api/packageApi"

function PackageRow({ packageData }) {
  const { id, name, credit, created_at, auto_renew, admin_count } = packageData
  const deleteModal = useDisclosure()
  const editModal = useDisclosure()
  const queryClient = useQueryClient()
  const { params, addParam } = useParamsQuery()

  // delete contract mutation
  const { mutate, isPending } = useMutation({
    mutationFn: deletePackage,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(["packages", params], ({ results, count }) => {
        const newResults = results.filter(item => {
          return item.id !== variables
        })
        if (newResults.length === 0 && params.page > 1) {
          addParam({ page: params.page - 1 })
        }
        return { count: count - 1, results: newResults }
      })
      deleteModal.close()
    },
    onError: error => toast.error(error),
  })

  return (
    <React.Fragment>
      {deleteModal.isOpen ? (
        <DeleteModal
          show={deleteModal.isOpen}
          onDeleteClick={() => mutate(id)}
          onCloseClick={deleteModal.close}
          isLoading={isPending}
        />
      ) : null}
      {editModal.isOpen ? (
        <EditPackageModal
          isOpen={editModal.isOpen}
          toggle={editModal.toggle}
          packageData={packageData}
        />
      ) : null}
      <tr>
        <td>{name}</td>
        <td>{admin_count}</td>
        <td>
          <StatusBadge label={String(auto_renew)} />
        </td>
        <td>{credit}</td>
        <td>{moment(created_at).format("l LT")}</td>
        <td className="d-flex gap-2">
          <Button size="sm" color="soft-success" onClick={editModal.open}>
            <i className="bx bx-pencil"></i>
          </Button>
          <Button size="sm" color="soft-danger" onClick={deleteModal.open}>
            <i className="bx bx-trash"></i>
          </Button>
        </td>
      </tr>
    </React.Fragment>
  )
}
PackageRow.propTypes = {
  packageData: PropTypes.object,
}

export default PackageRow
